import { isSindaraOrigin } from '@resources/lms-management/types'
import { TLMSClass } from './types'

export const shouldHideClassParticipantMigration = (classDetail?: TLMSClass) =>
  !classDetail || isSindaraOrigin(classDetail.origin)
